document.addEventListener('DOMContentLoaded', function () {
  //ECトップページ用
  const swiperTop = new Swiper('.mySwiper', {
    speed: 6000, // 表示切り替えのスピード
    // slidePerView: 5,
    allowTouchMove: true,
    loop: true, // ループさせる
    // centeredSlides: true,
    // 自動スライドについて
    autoplay: {
      delay: 0, // 何秒ごとにスライドを動かすか
      stopOnLastSlide: false, // 最後のスライドで自動再生を終了させるか
    },

    breakpoints: {
      1900: { slidesPerView: 6 },
      // 1600: { slidesPerView: 5.5 },
      1440: { slidesPerView: 5 },
      1000: { slidesPerView: 4 },
      768: { slidesPerView: 3.5 },
      600: { slidesPerView: 3 },
      500: { slidesPerView: 2.5 },
      400: { slidesPerView: 2 },
      375: { slidesPerView: 1.7 },
      0: { slidesPerView: 1.7 },
    },
  });

  const swiperCorp = new Swiper('.mySwiper_corp', {
    speed: 6000, 
    allowTouchMove: true,
    slidesPerView: 'auto',
    spaceBetween: 8,
    loop: true, 
    autoplay: {
      delay: 0, // 何秒ごとにスライドを動かすか
      stopOnLastSlide: false, // 最後のスライドで自動再生を終了させるか
    },

    breakpoints: {
      1440: { 
        spaceBetween: 16,
      },
      768: {
        speed: 12000,
      }
    },
  });  
});
